import { NextArrow, PrevArrow } from "@components/slider"
import clsx from "clsx"
import { ButtonGroupProps } from "react-multi-carousel"

interface BootcampSliderArrowProps extends ButtonGroupProps {
  displayedSlide: number
  length: number
  className?: string
}

export const BootcampSliderArrow: React.FC<BootcampSliderArrowProps> = ({
  next,
  previous,
  displayedSlide,
  length,
  className,
  ...props
}) => {
  const current = props.carouselState?.currentSlide

  if (length <= displayedSlide) {
    return <></>
  }

  return (
    <div className={clsx(`z-10 flex w-full`, className)}>
      <PrevArrow
        disabled={current === 0 || length < displayedSlide}
        className={clsx(
          // size === "lg" ? "w-[50px] h-[50px]" : 'w-[40px] h-[40px]',
          "flex items-center justify-center bg-white rounded-full",
          "w-[44px] h-[44px]"
        )}
        onClick={previous}
      />
      <NextArrow
        onClick={next}
        disabled={length - displayedSlide === current || length < displayedSlide}
        className={clsx(
          "flex items-center justify-center bg-white rounded-full",
          "w-[44px] h-[44px]"
        )}
      />
    </div>
  )
}

interface ArrowRowProp extends ButtonGroupProps {
  length: number
  size?: "md" | "lg"
  displayedSlide: number
  className?: string
  leftClassName?: string
  rightClassName?: string
  iconSize?: string
  isNew?: boolean
  customSize?: string
  customPosition?: string
}

interface SliderArrowProps extends ArrowRowProp {
  customBackground?: string
  customMargin?: string
}

export const SliderScrollArrow: React.FC<SliderArrowProps> = ({
  next,
  previous,
  length,
  displayedSlide,
  size,
  className,
  leftClassName,
  rightClassName,
  iconSize,
  isNew,
  customMargin,
  customBackground,
  ...props
}) => {
  const current = props.carouselState?.currentSlide
  const maxIndex = length - displayedSlide

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(e.target.value, 10)
    if (props) {
      // @ts-ignore
      props?.goToSlide(index, false) // false = no animation
    }
  }

  if (length <= displayedSlide) {
    return <></>
  }

  return (
    <div
      className={clsx(
        `z-10 flex w-full h-auto items-center gap-6`,
        className,
        customMargin ?? "my-6"
      )}
    >
      <PrevArrow
        disabled={current === 0 || length < displayedSlide}
        className={clsx("flex items-center justify-center bg-white rounded-full", "wh-8")}
        iconSize={iconSize}
        onClick={previous}
      />

      <input
        type="range"
        min={0}
        max={maxIndex}
        value={current}
        onChange={handleSliderChange}
        style={
          {
            ["--thumb-width" as string]: `${Math.floor(100 / length)}%`,
          } as React.CSSProperties
        }
        className={clsx("slider-range", customBackground)}
      />

      <NextArrow
        onClick={next}
        iconSize={iconSize}
        disabled={length - displayedSlide === current || length < displayedSlide}
        className={clsx(
          "flex items-center justify-center bg-white rounded-full",
          "wh-8",
          rightClassName
        )}
      />
    </div>
  )
}
